import { createDom, addClass } from 'xgplayer/src/utils/util'
import PlayNextIcon from '../assets/playNext.svg?raw'
import '../style/controls/myEpisode.scss'

let my_episode = function () {
  let player = this
  let hasEpisode = player.config.customConfig.hasEpisode
  if (!hasEpisode) {
    return
  }
  let btn = createDom('xg-my-episode', `<xg-icon class="xgplayer-icon">episode</xg-icon>`, {}, 'xgplayer-my-episode')
  let tipsText = player.lang.PLAYNEXT_TIPS
  let tips = createDom('xg-tips', `<span class="xgplayer-tip-playnext">${'切换集'}</span>`, {}, 'xgplayer-tips')
  btn.appendChild(tips)
  player.once('ready', () => {
    player.controls.appendChild(btn)
  })
  ;['click', 'touchend'].forEach((item) => {
    btn.addEventListener(item, (e) => {
      e.preventDefault()
      e.stopPropagation()
      // addClass(player.root, 'xgplayer-is-enter')
      // player.userGestureTrigEvent('openEpisode')
      // player.on('openEpisode', 1)
      player.emit('openEpisode', 1)
    })
  })

  function onDestroy() {
    // player.off('urlListEnd', onUrlListEnd)
    // player.off('destroy', onDestroy)
  }
  // player.once('destroy', onDestroy)
}

export default {
  name: 'my_episode',
  method: my_episode
}
